// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2OF1-","inputDescription":"styles_inputDescription__iCnax"};